<div *ngIf="!directSiteContentService.siteContent" class="place-self-center">
  <mat-spinner [diameter]="32"></mat-spinner>
</div>

<div
  *ngIf="directSiteContentService.siteContent"
  class="grid"
  [ngClass]="
    (isMobile$ | async) ? 'justify-center text-center' : 'grid-cols-[minmax(auto,510px)_1fr] gap-16 items-center'
  ">
  <div
    [ngClass]="{
      grid: isMobile$ | async
    }">
    <ng-container *ngIf="directAddService.currentStep === 3">
      <h2 class="m-0 mb-4">Add an eye catching title and sub title to your site hero</h2>
      <p class="m-0 mb-6">We added some suggestions for you based on your brand and property portfolio.</p>

      <sbnb-direct-hero-form></sbnb-direct-hero-form>
    </ng-container>

    <ng-container *ngIf="directAddService.currentStep === 4">
      <h2 class="m-0 mb-8">Does your business have a logo?</h2>

      <sbnb-upload-assets
        label="Logo"
        assetType="logo"
        [thumbnails]="[directSiteContentService.logo]"
        [options]="{
          maxFiles: 1,
          fromSources: ['local_file_system', 'url'],
          accept: ['image/jpeg', 'image/png']
        }"
        (uploadSuccess)="directSiteContentService.onLogoUploadSuccess($event)"
        (remove)="directSiteContentService.removeLogo()"></sbnb-upload-assets>
    </ng-container>

    <ng-container *ngIf="directAddService.currentStep === 5">
      <h2 class="m-0 mb-8">How do you want to showcase your property on your home page?</h2>

      <sbnb-upload-assets
        label="Hero background images"
        assetType="image"
        [thumbnails]="directSiteContentService.images"
        [options]="{
          maxFiles: 30,
          fromSources: ['local_file_system', 'url'],
          accept: ['image/jpeg', 'image/png']
        }"
        (uploadSuccess)="directSiteContentService.onGalleryUploadSuccess($event)"
        (remove)="directSiteContentService.removeImage($event)"></sbnb-upload-assets>

      <sbnb-upload-assets
        class="mt-8"
        label="Hero background video"
        assetType="video"
        [thumbnails]="[directSiteContentService.video ? 'https://placehold.co/300x300' : undefined]"
        [options]="{
          maxFiles: 1,
          maxSize: 30 * 1024 * 1024,
          fromSources: ['local_file_system', 'url'],
          accept: ['video/*']
        }"
        (uploadSuccess)="directSiteContentService.onVideoSuccess($event)"
        (remove)="directSiteContentService.removeVideo()"></sbnb-upload-assets>
    </ng-container>

    <sbnb-button
      class="mt-8 block"
      [ngClass]="(isMobile$ | async) ? 'justify-self-center' : 'justify-self-start'"
      [loading]="directSiteContentService.loading"
      (click)="continue()">
      Continue
    </sbnb-button>
  </div>

  <iframe
    *ngIf="iframeSrc && !(isMobile$ | async)"
    [src]="iframeSrc"
    frameborder="0"
    class="w-full aspect-video border border-smoke"
    style="zoom: 0.7"></iframe>
</div>
